import { createActions, createReducer } from 'reduxsauce';
import * as Immutable from 'seamless-immutable';
import * as R from 'ramda';

const tag = '[SAGA_AUTH_REDUX]';
const functionDefinitions = {
    startup: null,

    /*---------- login / logout ------*/
    requestLogin: [
        'username', 'password', 'returnUrl', 'officeId'
    ],
    loginSuccess: ['loginResponse'],
    loginFailure: ['loginError'],
    requestLogout: null,

    /*---------- officeList --------*/
    requestOfficeList: null,
    officeListSuccess: ['officeListResponse'],
    setCurrentOffice: ['currentOffice'],
    officeListFailure: ['officeListError'],

    /*---------- userProfile --------*/
    requestUserProfile: null,
    userProfileSuccess: ['userProfileResponse'],
    userProfileFailure: ['userProfileError'],

    /*---------- updateGlobalSetting --------*/
    updateGlobalSetting: ['setting'],
};

const { Types, Creators } = createActions(functionDefinitions);

export const SagaAuthReduxTypes = Types;
export default (Creators);

const LOGOUT_STATE = {
    username: null,
    password: null,
    returnUrl:null,
    loginResponse: null,
    loginError: null,
    loginFetching: false,
    userProfileResponse: null,
    userProfileFetching: false,
    userProfileError: null,
};

export const SagaAuthInitState = {
    ...LOGOUT_STATE,

    officeListResponse: null,
    officeListFetching: false,
    officeListError: null
};

const INITIAL_STATE = Immutable(SagaAuthInitState);

export const startup = (state) => {
    console.log(`${tag} Startup caught in sagaAuthRedux/startup function`);

    const startupState = {
        loginError: null,
        returnUrl: null,
        loginFetching: false
    };

    return state.merge(startupState);

};

/*/*---------- login / logout --------*/
export const requestLogin = (state, action) => {
    return state.merge({
        username: action.username,
        password: action.password,
        returnUrl: action.returnUrl,
        officeId: action.officeId,
        loginFetching: true,
        loginError: null,
        loginResponse: null
    });
};

export const loginSuccess = (state, action) => {
    return state.merge({ loginResponse: action.loginResponse, loginFetching: false });
};

export const loginFailure = (state, action) => {
    return state.merge({ loginError: action.loginError, loginFetching: false, loginResponse: null });
};

export const requestLogout = (state) => {
    return state.merge(LOGOUT_STATE);
};

/*---------- officeList --------*/

export const requestOfficeList = (state) => {
    return state.merge({ officeListFetching: true });
};
export const officeListSuccess = (state, action) => {
    return state.merge({ officeListFetching: false, officeListResponse: action.officeListResponse });
};
export const officeListFailure = (state, action) => {
    return state.merge({ officeListFetching: false, officeListError: action.officeListError });
};

export const setCurrentOffice = (state, action) => {
    return state.merge({ currentOffice: action.currentOffice });
};


/*---------- userProfile --------*/
export const requestUserProfile = (state) => {
    return state.merge({ userProfileFetching: true });
};
export const userProfileSuccess = (state, action) => {
    return state.merge({ userProfileFetching: false, userProfileResponse: action.userProfileResponse });
};
export const userProfileFailure = (state, action) => {
    return state.merge({ userProfileFetching: false, userProfileError: action.userProfileError });
};

/*---------- updateGlobalSetting --------*/
export const updateGlobalSetting = (state, action) => {
    if(action && action.setting && action.setting.officeSettings) {
        const currentOffice = Immutable.asMutable(state.currentOffice, { deep: true });
        // find current branch to fix settings
        const index = R.findIndex(R.propEq('branchId', currentOffice.id))(action.setting.officeSettings);
        if(index > -1) {
            currentOffice.enableTextSelection = action.setting.officeSettings[index].enableTextSelection;
            currentOffice.userIsolation = action.setting.officeSettings[index].userIsolation;
            return state.merge({ currentOffice }); 
        }
    }
    return state;
};

export const reducer = createReducer(INITIAL_STATE, {
    [Types.STARTUP]: startup,
    [Types.REQUEST_LOGIN]: requestLogin,
    [Types.LOGIN_SUCCESS]: loginSuccess,
    [Types.LOGIN_FAILURE]: loginFailure,
    [Types.REQUEST_LOGOUT]: requestLogout,

    /*---------- officeList --------*/
    [Types.REQUEST_OFFICE_LIST]: requestOfficeList,
    [Types.OFFICE_LIST_SUCCESS]: officeListSuccess,
    [Types.SET_CURRENT_OFFICE]: setCurrentOffice,
    [Types.OFFICE_LIST_FAILURE]: officeListFailure,

    /*---------- userProfile --------*/
    [Types.REQUEST_USER_PROFILE]: requestUserProfile,
    [Types.USER_PROFILE_SUCCESS]: userProfileSuccess,
    [Types.USER_PROFILE_FAILURE]: userProfileFailure,

    /*---------- userProfile --------*/
    [Types.UPDATE_GLOBAL_SETTING]: updateGlobalSetting,
});



// WEBPACK FOOTER //
// ./src/redux/sagaAuth/sagaAuthRedux.ts